export interface IGetDeviceDistanceTraveledOutputDto {
    value: string;
    unit: string;
}
